/**
 * Composant pour protéger les routes nécessitant une authentification
 */

import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext.jsx';
import { hasGovernorPermission } from '../hooks/useGovernorPermission.js';

export function ProtectedRoute({
  children,
  requiredType = null,
  allowedTypes = null,
  requiredGovernorPermission = null,
  fallbackTo = '/gouverneur/dashboard',
}) {
  const { isAuthenticated, loading, user } = useAuth();

  if (loading) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh' 
      }}>
        <div>Chargement...</div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // Vérifier le type d'utilisateur si requis (ancien système avec requiredType)
  if (requiredType && user?.type !== requiredType) {
    return <Navigate to="/" replace />;
  }

  // Vérifier le type d'utilisateur si requis (nouveau système avec allowedTypes)
  if (allowedTypes && Array.isArray(allowedTypes) && !allowedTypes.includes(user?.type)) {
    return <Navigate to="/" replace />;
  }

  if (
    requiredGovernorPermission
    && user?.type === 'gouverneur'
    && !hasGovernorPermission(user, requiredGovernorPermission)
  ) {
    return <Navigate to={fallbackTo} replace />;
  }

  return children;
}
